import styled from 'styled-components';

export const ThirdPartySSOLoginStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ThirdPartySSOLoginHead = styled.div`
    h1 {
        ${({ theme }) => theme.text.h1};
        margin-bottom: 8px;
        text-align: center;
    }
    p {
        ${({ theme }) => theme.text.normal};
        color: ${({ theme }) => theme.colors.text};
        text-align: center;
    }
`;

export const ThirdPartySSOLoginNote = styled.div`
    ${({ theme }) => theme.text.small};
    color: ${({ theme }) => theme.colors.textSecondary};
    text-align: center;
`;

export const ThirdPartySSOLoginControls = styled.div`
    display: flex;
    justify-content: center;
`;
